import { render, staticRenderFns } from "./SchoolOfArtsAndScience.vue?vue&type=template&id=2d19f6a4"
import script from "./SchoolOfArtsAndScience.vue?vue&type=script&lang=js"
export * from "./SchoolOfArtsAndScience.vue?vue&type=script&lang=js"
import style0 from "./SchoolOfArtsAndScience.vue?vue&type=style&index=0&id=2d19f6a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports